import { render, staticRenderFns } from "./PreviewProductModal.vue?vue&type=template&id=594574ae&scoped=true&"
import script from "./PreviewProductModal.vue?vue&type=script&lang=js&"
export * from "./PreviewProductModal.vue?vue&type=script&lang=js&"
import style0 from "./PreviewProductModal.vue?vue&type=style&index=0&id=594574ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594574ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('594574ae')) {
      api.createRecord('594574ae', component.options)
    } else {
      api.reload('594574ae', component.options)
    }
    module.hot.accept("./PreviewProductModal.vue?vue&type=template&id=594574ae&scoped=true&", function () {
      api.rerender('594574ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/orderMgt/modules/PreviewProductModal.vue"
export default component.exports